import React from "react";
import {useCollapse} from "react-collapsed";

const CollapsableSettingsCard = ({title, subtitle, content}: {
    title: string;
    subtitle: string;
    content: React.ReactNode
}): React.ReactElement => {

    const {getCollapseProps, getToggleProps, isExpanded} = useCollapse();

    return (
        <div>
            <div {...getToggleProps()} className="p-16 ast_collapseble">
                <h3><strong>{title}</strong></h3>
                <div>{subtitle}</div>
            </div>
            <section {...getCollapseProps()} className="pb-4 ast_collapseble-section">
                {isExpanded && content}
            </section>
        </div>
    );
};

export default CollapsableSettingsCard;